import { useEffect, useState } from "react";
import api from "../../lib/api";

const ACTION_LABELS = {
  create_claim: "Buat Klaim", approve_claim: "Approve", reject_claim: "Tolak", assign_claim: "Penugasan",
  complete_claim: "Selesai Investigasi", create_user: "Buat User", create_rule: "Buat Aturan",
  update_rule: "Ubah Aturan", delete_rule: "Hapus Aturan", update_threshold: "Ubah Threshold",
  create_phrase: "Tambah Frasa", update_phrase: "Ubah Frasa", delete_phrase: "Hapus Frasa",
};

export default function AuditTab() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/audit-logs").then((r) => setLogs(r.data)).catch(() => {}); }, []);

  return (
    <div className="bg-card border border-border" data-testid="audit-log-list">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-xs uppercase tracking-wider text-muted-foreground border-b border-border">
            <th className="px-4 py-3 font-medium">Waktu</th>
            <th className="px-3 py-3 font-medium">User</th>
            <th className="px-3 py-3 font-medium">Aksi</th>
            <th className="px-3 py-3 font-medium">Detail</th>
          </tr>
        </thead>
        <tbody>
          {logs.length === 0 && <tr><td colSpan={4} className="px-4 py-8 text-center text-muted-foreground">Belum ada aktivitas</td></tr>}
          {logs.map((l) => (
            <tr key={l.id} className="border-b border-border/60 last:border-0">
              <td className="px-4 py-2.5 font-mono text-xs text-muted-foreground whitespace-nowrap">
                {new Date(l.created_at).toLocaleString("id-ID", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" })}
              </td>
              <td className="px-3 py-2.5 text-xs">{l.user_name} <span className="text-muted-foreground">({l.user_role})</span></td>
              <td className="px-3 py-2.5 text-xs font-medium">{ACTION_LABELS[l.action] || l.action}</td>
              <td className="px-3 py-2.5 text-xs text-muted-foreground">{l.detail}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
